export default "__VITE_ASSET__ByzdAsPe__"